define(function(require) {
    return {
        ID : "PLANIFICATION",
        TYPE : "ThemeSetGroup",
        TITLE : "Planification des espaces",
        THEMESETS_ELEMENTS : [
            {
                ID : "PREVISIONS",
                TYPE : "ThemeSet",
                TITLE : "Prévision des effectifs scolaires",
                THEMESET_MAP_SETTINGS: {
                    LAYERS_SETTINGS : [
                        {LAYER_ID : "GEO09E32_GDUNO_IMMBL", VISIBLE : true, LABEL_VISIBLE : true},
                        {LAYER_ID : "GEO07E12_POINTS_SPES", VISIBLE : false, LABEL_VISIBLE : false},
                        {LAYER_ID : "DRAWING_LAYER", VISIBLE : false, LABEL_VISIBLE : false},
                        {LAYER_ID : "GEO07E15_SECT_SPES", VISIBLE : false, LABEL_VISIBLE : false},
                        {LAYER_ID : "CS_SPES", VISIBLE : false, LABEL_VISIBLE : false},
                        {LAYER_ID : "MUNCP_SPES", VISIBLE : false, LABEL_VISIBLE : false},
                        {LAYER_ID : "GEO09E56_ZONES_GRISES", VISIBLE : true, LABEL_VISIBLE : true},
                        {LAYER_ID : "GEO09E35_SECT_FRA_ZG", VISIBLE : true, LABEL_VISIBLE : true},
                        {LAYER_ID : "GEO09E35_SECT_FRA", VISIBLE : true, LABEL_VISIBLE : true},
                        {LAYER_ID : "GEO09E36_SECT_ANG", VISIBLE : true, LABEL_VISIBLE : true},
                        {LAYER_ID : "GEO09E37_SECT_STA", VISIBLE : true, LABEL_VISIBLE : true},
                        {LAYER_ID : "GEO09E01_CS_FRA", VISIBLE : true, LABEL_VISIBLE : true},
                        {LAYER_ID : "GEO09E02_CS_ANG", VISIBLE : true, LABEL_VISIBLE : true},
                        {LAYER_ID : "GEO09E03_CS_STA", VISIBLE : true, LABEL_VISIBLE : true},
                    ]
                },
                DEFAULT : true
            }, {
                ID : "BESOINS_ESPACE",
                TYPE : "ThemeSetGroup",
                TITLE : "Besoins d'espace",
                THEMESETS_ELEMENTS : [{
                    ID : "TA_PP",
                    TYPE : "ThemeSet",
                    TITLE : "Primaire",
                    THEMESET_MAP_SETTINGS : {
                        LAYERS_SETTINGS : [
                            {LAYER_ID : "GEO07E12_POINTS_SPES", VISIBLE : false, LABEL_VISIBLE : false},
                            {LAYER_ID : "DRAWING_LAYER", VISIBLE : false, LABEL_VISIBLE : false},
                            {LAYER_ID : "GEO07E15_SECT_SPES", VISIBLE : false, LABEL_VISIBLE : false},
                            {LAYER_ID : "CS_SPES", VISIBLE : false, LABEL_VISIBLE : false},
                            {LAYER_ID : "MUNCP_SPES", VISIBLE : false, LABEL_VISIBLE : false},
                            {LAYER_ID : "GEO09E66_TERRI_ANA_PP_FRA", VISIBLE : true, LABEL_VISIBLE : true},
                            {LAYER_ID : "GEO09E67_TERRI_ANA_PP_ANG", VISIBLE : true, LABEL_VISIBLE : true},
                        ]
                    },
                    THEMES : [
                        {
                            TYPE : "ThemeByRangesOfValues",
                            LAYER_ID : "GEO09E66_TERRI_ANA_PP_FRA",
                            DATATABLE_ID : "t_GEO09E66_TERRI_ANA_PP_FRA",
                            DATACOLUMN_ID : "NB_PE_40",
                            REPRESENTATION_ENUM : "color",
                            AS_OVERLAY : false,
                            ENABLED : true,
                            LEGEND_TEXT : "Nombre de classes en surplus/déficit",
                            NUMBER_OF_RANGES : 6,
                            SHOW_INDIVIDUAL_VALES_WITH_ZERO_COUNT : true,
                            SCHEME : {
                                ID : "FRA_TA_PP",
                                SCHEME_ELEMENTS : [
                                    {
                                        MIN_VALUE : Number.NEGATIVE_INFINITY,
                                        MAX_VALUE : -24,
                                        REPRESENTATION : "rgba(215,48,39,1)",
                                        LEGEND_TEXT : "moins de -24 classes"
                                    }, {
                                        MIN_VALUE : -24,
                                        MAX_VALUE : -14,
                                        REPRESENTATION : "rgba(252,141,89,1)",
                                        LEGEND_TEXT : "-24 à -14 classes"
                                    }, {
                                        MIN_VALUE :-14,
                                        MAX_VALUE : -3,
                                        REPRESENTATION : "rgba(254,224,144,1)",
                                        LEGEND_TEXT : "-14 à -3 classes"
                                    }, {
                                        MIN_VALUE : -3,
                                        MAX_VALUE : 5,
                                        REPRESENTATION : "rgba(217,239,139,1)",
                                        LEGEND_TEXT : "-3 à 5 classes"
                                    }, {
                                        MIN_VALUE : 5,
                                        MAX_VALUE : 21,
                                        REPRESENTATION : "rgba(145,207,96,1)",
                                        LEGEND_TEXT : "5 à 21 classes"
                                    }, {
                                        MIN_VALUE : 21,//inclus
                                        MAX_VALUE : Number.POSITIVE_INFINITY,
                                        REPRESENTATION : "rgba(26,152,80,1)",
                                        LEGEND_TEXT : "21 classes et plus"
                                    }]
                            }
                        }, /*{
                            TYPE : "ThemeByRangesOfValues",
                            LAYER_ID : "GEO09E67_TERRI_ANA_PP_ANG",
                            DATATABLE_ID : "t_GEO09E67_TERRI_ANA_PP_ANG",
                            DATACOLUMN_ID : "NB_PE_40",
                            REPRESENTATION_ENUM : "color",
                            AS_OVERLAY : false,
                            ENABLED : true,
                            LEGEND_TEXT : "Nombre de classes en surplus/déficit",
                            NUMBER_OF_RANGES : 6,
                            SHOW_INDIVIDUAL_VALES_WITH_ZERO_COUNT : true,
                            SCHEME : {
                                ID : "ANG_TA_PP",
                                SCHEME_ELEMENTS : [
                                    {
                                        MIN_VALUE : Number.NEGATIVE_INFINITY,
                                        MAX_VALUE : -24,
                                        REPRESENTATION : "rgba(215,48,39,1)",
                                        LEGEND_TEXT : "moins de -24 classes"
                                    }, {
                                        MIN_VALUE : -24,
                                        MAX_VALUE : -14,
                                        REPRESENTATION : "rgba(252,141,89,1)",
                                        LEGEND_TEXT : "-24 à -14 classes"
                                    }, {
                                        MIN_VALUE :-14,
                                        MAX_VALUE : -3,
                                        REPRESENTATION : "rgba(254,224,144,1)",
                                        LEGEND_TEXT : "-14 à -3 classes"
                                    }, {
                                        MIN_VALUE : -3,
                                        MAX_VALUE : 5,
                                        REPRESENTATION : "rgba(217,239,139,1)",
                                        LEGEND_TEXT : "-3 à 5 classes"
                                    }, {
                                        MIN_VALUE : 5,
                                        MAX_VALUE : 21,
                                        REPRESENTATION : "rgba(145,207,96,1)",
                                        LEGEND_TEXT : "5 à 21 classes"
                                    }, {
                                        MIN_VALUE : 21,//inclus
                                        MAX_VALUE : Number.POSITIVE_INFINITY,
                                        REPRESENTATION : "rgba(26,152,80,1)",
                                        LEGEND_TEXT : "21 classes et plus"
                                    }]
                            }
                        },*/
                    ]
                }, {
                    ID : "TA_S",
                    TYPE : "ThemeSet",
                    TITLE : "Secondaire",
                    THEMESET_MAP_SETTINGS : {
                        LAYERS_SETTINGS : [
                            {LAYER_ID : "GEO07E12_POINTS_SPES", VISIBLE : false, LABEL_VISIBLE : false},
                            {LAYER_ID : "DRAWING_LAYER", VISIBLE : false, LABEL_VISIBLE : false},
                            {LAYER_ID : "GEO07E15_SECT_SPES", VISIBLE : false, LABEL_VISIBLE : false},
                            {LAYER_ID : "CS_SPES", VISIBLE : false, LABEL_VISIBLE : false},
                            {LAYER_ID : "MUNCP_SPES", VISIBLE : false, LABEL_VISIBLE : false},
                            {LAYER_ID : "GEO09E69_TERRI_ANA_S_FRA", VISIBLE : true, LABEL_VISIBLE : true},
                            {LAYER_ID : "GEO09E70_TERRI_ANA_S_ANG", VISIBLE : true, LABEL_VISIBLE : true},
                        ]
                    },
                    THEMES : [
                        {
                            TYPE : "ThemeByRangesOfValues",
                            LAYER_ID : "GEO09E69_TERRI_ANA_S_FRA",
                            DATATABLE_ID : "t_GEO09E69_TERRI_ANA_S_FRA",
                            DATACOLUMN_ID : "NB_PE",
                            REPRESENTATION_ENUM : "color",
                            AS_OVERLAY : false,
                            ENABLED : true,
                            LEGEND_TEXT : "Nombre de places-élèves en surplus/déficit",
                            NUMBER_OF_RANGES : 5,
                            SHOW_INDIVIDUAL_VALES_WITH_ZERO_COUNT : true,
                            SCHEME : {
                                ID : "FRA_TA_S",
                                SCHEME_ELEMENTS : [
                                    {
                                        MIN_VALUE : Number.NEGATIVE_INFINITY,
                                        MAX_VALUE : -999,
                                        REPRESENTATION : "rgba(215, 25, 28,1)",
                                        LEGEND_TEXT : "moins de -999 places-élèves"
                                    }, {
                                        MIN_VALUE : -999,
                                        MAX_VALUE : -124,
                                        REPRESENTATION : "rgba(253, 174, 97,1)",
                                        LEGEND_TEXT : "-999 à -124 places-élèves"
                                    }, {
                                        MIN_VALUE : -124,
                                        MAX_VALUE : 125,
                                        REPRESENTATION : "rgba(255, 255, 191,1)",
                                        LEGEND_TEXT : "-124 à 125 places-élèves"
                                    }, {
                                        MIN_VALUE : 125,
                                        MAX_VALUE : 1000,
                                        REPRESENTATION : "rgba(166, 217, 106,1)",
                                        LEGEND_TEXT : "125 à 1000 places-élèves"
                                    }, {
                                        MIN_VALUE : 1000,//inclus
                                        MAX_VALUE : Number.POSITIVE_INFINITY,
                                        REPRESENTATION : "rgba(26, 150, 65,1)",
                                        LEGEND_TEXT : "1000 places-élèves et plus"
                                    }]
                            }
                        }, /*{
                            TYPE : "ThemeByRangesOfValues",
                            LAYER_ID : "GEO09E70_TERRI_ANA_S_ANG",
                            DATATABLE_ID : "t_GEO09E70_TERRI_ANA_S_ANG",
                            DATACOLUMN_ID : "NB_PE",
                            REPRESENTATION_ENUM : "color",
                            AS_OVERLAY : false,
                            ENABLED : true,
                            LEGEND_TEXT : "Nombre de places-élèves en surplus/déficit",
                            NUMBER_OF_RANGES : 5,
                            SHOW_INDIVIDUAL_VALES_WITH_ZERO_COUNT : true,
                            SCHEME : {
                                ID : "ANG_TA_S",
                                SCHEME_ELEMENTS : [
                                    {
                                        MIN_VALUE : Number.NEGATIVE_INFINITY,
                                        MAX_VALUE : -999,
                                        REPRESENTATION : "rgba(215, 25, 28,1)",
                                        LEGEND_TEXT : "moins de -999 places-élèves"
                                    }, {
                                        MIN_VALUE : -999,
                                        MAX_VALUE : -124,
                                        REPRESENTATION : "rgba(253, 174, 97,1)",
                                        LEGEND_TEXT : "-999 à -124 places-élèves"
                                    }, {
                                        MIN_VALUE : -124,
                                        MAX_VALUE : 125,
                                        REPRESENTATION : "rgba(255, 255, 191,1)",
                                        LEGEND_TEXT : "-124 à 125 places-élèves"
                                    }, {
                                        MIN_VALUE : 125,
                                        MAX_VALUE : 1000,
                                        REPRESENTATION : "rgba(166, 217, 106,1)",
                                        LEGEND_TEXT : "125 à 1000 places-élèves"
                                    }, {
                                        MIN_VALUE : 1000,//inclus
                                        MAX_VALUE : Number.POSITIVE_INFINITY,
                                        REPRESENTATION : "rgba(26, 150, 65,1)",
                                        LEGEND_TEXT : "1000 places-élèves et plus"
                                    }]
                            }
                        },*/
                    ]
                }],
            }
        ]
    }
});
